// import React, { useEffect, useState } from "react";
// import {
//   Button,
//   Card,
//   Col,
//   Container,
//   Row,
//   Table,
//   Modal,
//   Form,
// } from "react-bootstrap";
// import BreadCrumb from "Common/BreadCrumb";
// import { addTaxes, getTaxes, updateTax, deleteTaxes } from "api/apis";

// interface Tax {
//   _id: string;
//   type: string;
//   rate: number;
// }

// const Taxes = () => {
//   document.title = "Taxes | Toner eCommerce + Admin React Template";

//   const [taxes, setTaxes] = useState<Tax[]>([]);
//   const [showModal, setShowModal] = useState(false);
//   const [type, setType] = useState("");
//   const [rate, setRate] = useState("");
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [editTaxId, setEditTaxId] = useState<string | null>(null);
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [taxToDelete, setTaxToDelete] = useState<Tax | null>(null);

//   const fetchTaxes = async () => {
//     try {
//       const response = await getTaxes();
//       setTaxes(response || []);
//     } catch (error) {
//       console.error("Failed to fetch taxes:", error);
//     }
//   };

//   const handleAddOrUpdateTax = async () => {
//     try {
//       if (isEditMode && editTaxId) {
//         await updateTax({ type, rate: Number(rate) }, editTaxId);
//         await fetchTaxes();
//       } else {
//         const newTax = await addTaxes({ type, rate: Number(rate) });
//         setTaxes((prev) => [...prev, newTax]);
//       }

//       // Reset modal state
//       setShowModal(false);
//       setType("");
//       setRate("");
//       setIsEditMode(false);
//       setEditTaxId(null);
//     } catch (error) {
//       console.error("Failed to add/update tax:", error);
//     }
//   };

//   const handleEditClick = (tax: Tax) => {
//     setType(tax.type);
//     setRate(tax.rate.toString());
//     setEditTaxId(tax._id);
//     setIsEditMode(true);
//     setShowModal(true);
//   };

//   const handleDeleteClick = (tax: Tax) => {
//     setTaxToDelete(tax);
//     setShowDeleteModal(true);
//   };

//   useEffect(() => {
//     fetchTaxes();
//   }, []);

//   return (
//     <React.Fragment>
//       <div className="page-content">
//         <Container fluid>
//           <BreadCrumb title="Taxes" pageTitle="Configuration" />

//           <Row>
//             <Col lg={12}>
//               <div className="d-flex justify-content-between align-items-center mb-3">
//                 <h5 className="mb-0">All Tax Records</h5>
//                 <Button
//                   variant="success"
//                   onClick={() => {
//                     setShowModal(true);
//                     setIsEditMode(false);
//                     setType("");
//                     setRate("");
//                   }}
//                 >
//                   + Add Tax
//                 </Button>
//               </div>

//               <Card>
//                 <Card.Body>
//                   <Table responsive borderless className="align-middle">
//                     <thead className="table-light">
//                       <tr>
//                         <th style={{ width: "5%" }}>#</th>
//                         <th style={{ width: "35%" }}>Type</th>
//                         <th style={{ width: "20%" }}>Rate (%)</th>
//                         <th className="text-end" style={{ width: "20%" }}>
//                           Actions
//                         </th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {taxes.length === 0 ? (
//                         <tr>
//                           <td colSpan={4} className="text-center py-4">
//                             No tax records found.
//                           </td>
//                         </tr>
//                       ) : (
//                         taxes.map((tax, index) => (
//                           <tr key={tax._id}>
//                             <td>{index + 1}</td>
//                             <td>{tax.type}</td>
//                             <td>{tax.rate}</td>
//                             <td className="text-end">
//                               <i
//                                 className="ri-pencil-fill text-primary me-3"
//                                 style={{ cursor: "pointer" }}
//                                 onClick={() => handleEditClick(tax)}
//                               ></i>
//                               <i
//                                 className="ri-delete-bin-fill text-danger"
//                                 style={{ cursor: "pointer" }}
//                                 onClick={() => handleDeleteClick(tax)}
//                               ></i>
//                             </td>
//                           </tr>
//                         ))
//                       )}
//                     </tbody>
//                   </Table>
//                 </Card.Body>
//               </Card>
//             </Col>
//           </Row>
//         </Container>

//         {/* Modal for Add/Edit Tax */}
//         <Modal show={showModal} onHide={() => setShowModal(false)}>
//           <Modal.Header closeButton>
//             <Modal.Title>{isEditMode ? "Edit Tax" : "Add New Tax"}</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <Form>
//               <Form.Group controlId="taxType" className="mb-3">
//                 <Form.Label>Type</Form.Label>
//                 <Form.Control
//                   type="text"
//                   value={type}
//                   onChange={(e) => setType(e.target.value)}
//                   placeholder="Enter tax type (e.g., GST)"
//                 />
//               </Form.Group>
//               <Form.Group controlId="taxRate" className="mb-3">
//                 <Form.Label>Rate (%)</Form.Label>
//                 <Form.Control
//                   type="number"
//                   value={rate}
//                   onChange={(e) => setRate(e.target.value)}
//                   placeholder="Enter rate"
//                 />
//               </Form.Group>
//             </Form>
//           </Modal.Body>
//           <Modal.Footer>
//             <Button variant="secondary" onClick={() => setShowModal(false)}>
//               Cancel
//             </Button>
//             <Button variant="primary" onClick={handleAddOrUpdateTax}>
//               {isEditMode ? "Update" : "Add"} Tax
//             </Button>
//           </Modal.Footer>
//         </Modal>

//         {/* {Modal for delete Tax} */}
//         <Modal
//           show={showDeleteModal}
//           onHide={() => setShowDeleteModal(false)}
//           centered
//         >
//           <Modal.Header closeButton>
//             <Modal.Title>Confirm Delete</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             Are you sure you want to delete the tax{" "}
//             <strong>{taxToDelete?.type}</strong>?
//           </Modal.Body>
//           <Modal.Footer>
//             <Button
//               variant="secondary"
//               onClick={() => setShowDeleteModal(false)}
//             >
//               Cancel
//             </Button>
//             <Button
//               variant="danger"
//               onClick={async () => {
//                 if (taxToDelete) {
//                   try {
//                     await deleteTaxes(taxToDelete._id);
//                     setTaxes((prev) =>
//                       prev.filter((t) => t._id !== taxToDelete._id)
//                     );
//                   } catch (error) {
//                     console.error("Failed to delete tax:", error);
//                   }
//                 }
//                 setShowDeleteModal(false);
//                 setTaxToDelete(null);
//               }}
//             >
//               Delete
//             </Button>
//           </Modal.Footer>
//         </Modal>
//       </div>
//     </React.Fragment>
//   );
// };

// export default Taxes;

import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Row,
  Table,
  Modal,
  Form,
} from "react-bootstrap";
import BreadCrumb from "Common/BreadCrumb";
import {
  addTaxes,
  getTaxes,
  updateTax,
  deleteTaxes,
  getGoldPriceByKarat,
  createAttribute,
  getAllAttributes,
  getAllAttributeSets,
  createAttributeSet,
  deleteAttribute,
  deleteAttributeSet,
  updateAttribute,
  updateAttributeSet,
  fetchBasePrice,
  saveOrUpdateBasePrice,
  updateOrAddKaratPricePercentage,
  getAllKaratPrices,
  deleteKaratPrice,
} from "api/apis";
import { updateGoldPrice } from "api/apis";
import { Attribute, AttributePayload, AttributeSet } from "interface";
import { toast } from "react-toastify";

interface Tax {
  _id: string;
  type: string;
  rate: number;
}

interface KaratPrice {
  karat: string;
  percentage: number;
}

const Taxes = () => {
  document.title = "Taxes";

  // Existing states
  const [taxes, setTaxes] = useState<Tax[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [type, setType] = useState("");
  const [rate, setRate] = useState("");
  const [isEditMode, setIsEditMode] = useState(false);
  const [editTaxId, setEditTaxId] = useState<string | null>(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [taxToDelete, setTaxToDelete] = useState<Tax | null>(null);
  const [goldPrice24K, setGoldPrice24K] = useState<string>("");
  const [isLoadingGoldPrice, setIsLoadingGoldPrice] = useState(false);

  // New states for Attributes
  const [attributes, setAttributes] = useState<Attribute[]>([]);
  const [showAttributeModal, setShowAttributeModal] = useState(false);
  const [showAttributeSetModal, setShowAttributeSetModal] = useState(false);
  const [attributeType, setAttributeType] = useState<
    "string" | "number" | "boolean" | "options"
  >("string");
  const [options, setOptions] = useState([""]);
  const [selectedAttributes, setSelectedAttributes] = useState<string[]>([]);
  const [attributeName, setAttributeName] = useState("");
  const [attributeSetName, setAttributeSetName] = useState("");
  const [isRequired, setIsRequired] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [attributeSets, setAttributeSets] = useState<AttributeSet[]>([]);
  const [showDeleteAttributeModal, setShowDeleteAttributeModal] =
    useState(false);
  const [attributeToDelete, setAttributeToDelete] = useState<Attribute | null>(
    null
  );
  const [currentGoldPrice, setCurrentGoldPrice] = useState<string | null>(null);
  const [showDeleteAttributeSetModal, setShowDeleteAttributeSetModal] =
    useState(false);
  const [attributeSetToDelete, setAttributeSetToDelete] =
    useState<AttributeSet | null>(null);

  const [editAttribute, setEditAttribute] = useState<Attribute | null>(null);
  const [editAttributeSet, setEditAttributeSet] = useState<AttributeSet | null>(
    null
  );
  const [isVariable, setIsVariable] = useState(false);
  const [isCharge, setIsCharge] = useState(false);
  const [karatPrices, setKaratPrices] = useState<KaratPrice[]>([]);
  const [showKaratPriceModal, setShowKaratPriceModal] = useState(false);
  const [editingKaratPrice, setEditingKaratPrice] = useState<KaratPrice | null>(null)
  const handleAddOption = () => setOptions([...options, ""]);
  const handleOptionChange = (index: number, value: string) => {
    const newOptions = [...options];
    newOptions[index] = value;
    setOptions(newOptions);
  };
  const handleRemoveOption = (index: number) => {
    const newOptions = [...options];
    newOptions.splice(index, 1);
    setOptions(newOptions);
  };

  const handleEditAttributeClick = (attribute: Attribute) => {
    setEditAttribute(attribute);
    setAttributeName(attribute.label);
    setAttributeType(attribute.type);
    setIsCharge(attribute.isCharge || false);
    setIsVariable(attribute.isVariable || false);
    setIsRequired(attribute.isRequired || false);
    setOptions(
      attribute.type === "options" && attribute.options
        ? [...attribute.options]
        : [""]
    );
    setShowAttributeModal(true);
  };

  const handleEditAttributeSetClick = (attributeSet: AttributeSet) => {
    setEditAttributeSet(attributeSet);
    setAttributeSetName(attributeSet.name);
    setSelectedAttributes(attributeSet.attributes.map((attr) => attr._id));
    setShowAttributeSetModal(true);
  };

  const handleUpdateAttributeSet = async () => {
    if (!editAttributeSet) return;

    try {
      setIsLoading(true);

      const payload = {
        name: attributeSetName,
        attributes: selectedAttributes,
      };

      const updatedAttributeSet = await updateAttributeSet(
        editAttributeSet._id,
        payload
      );

      // Update the attributeSets state
      setAttributeSets(
        attributeSets.map((set) =>
          set._id === editAttributeSet._id ? updatedAttributeSet : set
        )
      );

      // Reset form and close modal
      setShowAttributeSetModal(false);
      setEditAttributeSet(null);
      setAttributeSetName("");
      setSelectedAttributes([]);
    } catch (error) {
      console.error("Error updating attribute set:", error);
      alert("Failed to update attribute set. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const fetchKaratPrices = async () => {
    try {
      const response = await getAllKaratPrices();
      setKaratPrices(response);
    } catch (error) {
      console.error("Failed to fetch karat prices:", error);
    }
  };

  const handleUpdateKaratPrice = async (karat: string, percentage: number) => {
    try {
      await updateOrAddKaratPricePercentage({ karat, percentage });
      await fetchKaratPrices();
    } catch (error) {
      console.error("Failed to update karat price:", error);
    }
  };
  const handleDeleteKaratPrice = async (karat: string) => {
    try {
      await deleteKaratPrice(karat);
      await fetchKaratPrices();
      toast.success(`${karat} price deleted successfully!`);
    } catch (error) {
      console.error("Failed to delete karat price:", error);
      toast.error(`Failed to delete ${karat} price`);
    }
  };

  const handleDeleteAttributeClick = (attribute: Attribute) => {
    setAttributeToDelete(attribute);
    setShowDeleteAttributeModal(true);
  };

  const handleDeleteAttributeSetClick = (attributeSet: AttributeSet) => {
    setAttributeSetToDelete(attributeSet);
    setShowDeleteAttributeSetModal(true);
  };

  const handleConfirmDeleteAttributeSet = async () => {
    if (!attributeSetToDelete) return;

    try {
      await deleteAttributeSet(attributeSetToDelete._id);

      // Update attributeSets state
      const updatedAttributeSets = attributeSets.filter(
        (set) => set._id !== attributeSetToDelete._id
      );
      setAttributeSets(updatedAttributeSets);

      setShowDeleteAttributeSetModal(false);
      setAttributeSetToDelete(null);
    } catch (error) {
      console.error("Failed to delete attribute set:", error);
      alert("Failed to delete attribute set");
    }
  };

  const handleConfirmDeleteAttribute = async () => {
    if (!attributeToDelete) return;

    try {
      await deleteAttribute(attributeToDelete._id);

      // Update attributes state
      const updatedAttributes = attributes.filter(
        (attr) => attr._id !== attributeToDelete._id
      );
      setAttributes(updatedAttributes);

      // Safely update attributeSets state if it exists
      if (Array.isArray(attributeSets)) {
        const updatedAttributeSets = attributeSets.map((set) => ({
          ...set,
          attributes: set.attributes.filter((attr) => {
            // Handle both string IDs and populated attribute objects
            if (typeof attr === "string") {
              return attr !== attributeToDelete._id;
            } else {
              return (attr as Attribute)._id !== attributeToDelete._id;
            }
          }),
        }));
        setAttributeSets(updatedAttributeSets);
      }

      setShowDeleteAttributeModal(false);
      setAttributeToDelete(null);
    } catch (error) {
      console.error("Failed to delete attribute:", error);
      alert("Failed to delete attribute");
    }
  };

  useEffect(() => {
    const loadBasePrice = async () => {
      try {
        setIsLoadingGoldPrice(true);
        const response = await fetchBasePrice();
        setCurrentGoldPrice(response.price.toString());
        // Also set the input field value
        setGoldPrice24K(response.price.toString());
      } catch (error) {
        console.error("Error fetching base price:", error);
      } finally {
        setIsLoadingGoldPrice(false);
      }
    };

    loadBasePrice();
  }, []);

  const handleGoldInputChange = (value: string) => {
    // Basic validation to ensure only numbers are entered
    if (/^\d*\.?\d*$/.test(value)) {
      setGoldPrice24K(value);
    }
  };

  const handleSaveGoldPrice = async () => {
    try {
      if (!goldPrice24K) {
        alert("Please enter gold price.");
        return;
      }

      setIsLoadingGoldPrice(true);
      await saveOrUpdateBasePrice(Number(goldPrice24K));
      alert("24K Gold price updated successfully.");
      // Refresh the displayed price
      const response = await fetchBasePrice();
      setCurrentGoldPrice(response.price.toString());
      // Update the input field with the new price instead of clearing it
      setGoldPrice24K(response.price.toString());
    } catch (error) {
      console.error("Error updating gold price:", error);
      alert("Failed to update gold price.");
    } finally {
      setIsLoadingGoldPrice(false);
    }
  };

  const fetchTaxes = async () => {
    try {
      const response = await getTaxes();
      setTaxes(response || []);
    } catch (error) {
      console.error("Failed to fetch taxes:", error);
    }
  };

  const fetchGoldPrice = async () => {
    try {
      setIsLoadingGoldPrice(true);
      const goldPriceData = await fetchBasePrice();
      if (goldPriceData) {
        setGoldPrice24K(goldPriceData.price.toString());
      }
    } catch (error) {
      console.error("Failed to fetch gold price:", error);
      setGoldPrice24K("");
    } finally {
      setIsLoadingGoldPrice(false);
    }
  };

  const handleAddOrUpdateTax = async () => {
    try {
      if (isEditMode && editTaxId) {
        await updateTax({ type, rate: Number(rate) }, editTaxId);
        const response = await getTaxes();
        setTaxes(response || []);
      } else {
        await addTaxes({ type, rate: Number(rate) });
        const response = await getTaxes();
        setTaxes(response || []);
      }

      // Reset modal state
      setShowModal(false);
      setType("");
      setRate("");
      setIsEditMode(false);
      setEditTaxId(null);
    } catch (error) {
      console.error("Failed to add/update tax:", error);
    }
  };

  const handleEditClick = (tax: Tax) => {
    setType(tax.type);
    setRate(tax.rate.toString());
    setEditTaxId(tax._id);
    setIsEditMode(true);
    setShowModal(true);
  };

  const handleDeleteClick = (tax: Tax) => {
    setTaxToDelete(tax);
    setShowDeleteModal(true);
  };

  useEffect(() => {
    fetchGoldPrice();
    fetchTaxes();
    fetchKaratPrices();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsFetching(true);

        // First fetch attributes
        const attributesResponse = await getAllAttributes();
        setAttributes(attributesResponse || []);

        // Then fetch attribute sets
        const attributeSetsResponse = await getAllAttributeSets();
        setAttributeSets(attributeSetsResponse || []);
      } catch (error) {
        console.error("Error fetching data:", error);
        alert("Failed to load data");
        setAttributes([]);
        setAttributeSets([]);
      } finally {
        setIsFetching(false);
      }
    };

    fetchData();
  }, []);

  // Attribute functions
  const handleAddAttribute = async () => {
    try {
      setIsLoading(true);

      const payload = {
        label: attributeName,
        type: attributeType,
        isVariable,
        isCharge,
        isRequired,
        ...(attributeType === "options" && {
          options: options.filter((opt) => opt.trim() !== ""),
        }),
      };

      const response = await createAttribute(payload);
      setAttributes([...attributes, response]);

      // Reset form
      setShowAttributeModal(false);
      setAttributeName("");
      setAttributeType("string");
      setOptions([""]);
      setIsVariable(false);
      setIsRequired(false);
    } catch (error) {
      console.error("Error adding attribute:", error);
      alert("Failed to add attribute. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddAttributeSet = async () => {
    try {
      setIsLoading(true);

      const payload = {
        name: attributeSetName,
        attributes: selectedAttributes,
      };

      const response = await createAttributeSet(payload);

      // Instead of just spreading, we should fetch the updated list
      const updatedAttributeSets = await getAllAttributeSets();
      setAttributeSets(updatedAttributeSets || []);

      // Reset form
      setShowAttributeSetModal(false);
      setAttributeSetName("");
      setSelectedAttributes([]);
    } catch (error) {
      console.error("Error adding attribute set:", error);
      alert("Failed to add attribute set. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const toggleAttributeSelection = (attributeId: string) => {
    setSelectedAttributes((prev) =>
      prev.includes(attributeId)
        ? prev.filter((id) => id !== attributeId)
        : [...prev, attributeId]
    );
  };

  // Helper function to render attribute names for attribute sets
  const renderAttributeNames = (setAttributes: any[]) => {
    if (!setAttributes || setAttributes.length === 0) {
      return <span className="text-muted">No attributes</span>;
    }

    return setAttributes.map((attr, index) => {
      // Check if attr is populated (object) or just an ID (string)
      const attributeName =
        typeof attr === "object" && attr.label
          ? attr.label
          : typeof attr === "string"
            ? getAttributeNameById(attr)
            : "Unknown";

      return (
        <span
          key={typeof attr === "object" ? attr._id : attr || index}
          className="badge bg-primary me-2"
        >
          {attributeName}
        </span>
      );
    });
  };

  // Get attribute name by ID (fallback for non-populated attributes)
  const getAttributeNameById = (id: string) => {
    const attribute = attributes.find((attr) => attr._id === id);
    return attribute ? attribute.label : "Unknown Attribute";
  };

  // const handleUpdateAttribute = async () => {
  //   if (!editAttribute) return;

  //   try {
  //     setIsLoading(true);

  //     const payload = {
  //       name: attributeName,
  //       type: attributeType,
  //       ...(attributeType === "select" && {
  //         options: attributeOptions
  //           .split(",")
  //           .map((opt) => opt.trim())
  //           .filter((opt) => opt),
  //       }),
  //       isRequired,
  //     };

  //     const updatedAttribute = await updateAttribute(
  //       editAttribute._id,
  //       payload
  //     );

  //     // Update the attributes state
  //     setAttributes(
  //       attributes.map((attr) =>
  //         attr._id === editAttribute._id ? updatedAttribute : attr
  //       )
  //     );

  //     // Reset form and close modal
  //     setShowAttributeModal(false);
  //     setEditAttribute(null);
  //     setAttributeName("");
  //     setAttributeType("string");
  //     setAttributeOptions("");
  //     setIsRequired(false);
  //   } catch (error) {
  //     console.error("Error updating attribute:", error);
  //     alert("Failed to update attribute. Please try again.");
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleUpdateAttribute = async () => {
    if (!editAttribute) return;

    try {
      setIsLoading(true);

      const payload: AttributePayload = {
        label: attributeName,
        type: attributeType,
        isRequired,
        isVariable,
        isCharge,
        options,
      };

      const updated = await updateAttribute(editAttribute._id, payload);

      setAttributes((prev) =>
        prev.map((attr) => (attr._id === updated._id ? updated : attr))
      );

      setShowAttributeModal(false);
      setEditAttribute(null);
      setAttributeName("");
      setAttributeType("string");
      setOptions([""]);
      setIsVariable(false);
      setIsRequired(false);
    } catch (error) {
      console.error("Error updating attribute:", error);
      alert("Failed to update attribute. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseAttributeModal = () => {
    setShowAttributeModal(false);
    setEditAttribute(null);
    setAttributeName("");
    setAttributeType("string");
    setIsCharge(false);
    // setAttributeOptions("");
    setIsRequired(false);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Settings" pageTitle="Configuration" />

          {/* Simplified Gold Price Section - 24K only */}
          <Row className="mb-4">
            <Col lg={12}>
              <Card>
                <Card.Body>
                  <h5 className="card-title mb-3">24K Gold Price Per Gram</h5>
                  {currentGoldPrice && (
                    <p className="mb-3">Current Price: {currentGoldPrice}</p>
                  )}
                  <div className="d-flex align-items-center gap-3">
                    <div className="d-flex align-items-center gap-2">
                      <Form.Control
                        type="number"
                        value={goldPrice24K}
                        onChange={(e) => handleGoldInputChange(e.target.value)}
                        placeholder="Enter 24K gold price"
                        style={{ width: "150px" }}
                        min={0}
                        step="0.01"
                        disabled={isLoadingGoldPrice}
                      />
                    </div>
                    <Button
                      variant="primary"
                      onClick={handleSaveGoldPrice}
                      disabled={!goldPrice24K || isLoadingGoldPrice}
                    >
                      {isLoadingGoldPrice ? "Updating..." : "Update Price"}
                    </Button>
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
          <Row className="mb-4">
            <Col lg={12}>
              <Card>
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h5 className="card-title mb-0">Karat Percentage</h5>
                    <Button
                      variant="success"
                      onClick={() => {
                        setEditingKaratPrice({ karat: "", percentage: 0 });
                        setShowKaratPriceModal(true);
                      }}
                    >
                      + Add Karat Price
                    </Button>
                  </div>
                  <Table responsive>
                    <thead>
                      <tr>
                        <th>Karat</th>
                        <th>Percentage</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {karatPrices.map((price) => (
                        <tr key={price.karat}>
                          <td>{price.karat}</td>
                          <td>{price.percentage}%</td>
                          <td>
                            <Button
                              variant="primary"
                              size="sm"
                              onClick={() => {
                                setEditingKaratPrice(price);
                                setShowKaratPriceModal(true);
                              }}
                            >
                              Edit
                            </Button>
                            <Button
                              variant="danger"
                              size="sm"
                              onClick={() => handleDeleteKaratPrice(price?.karat)}
                              className="ms-2"
                            >
                              Delete
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Modal
            show={showKaratPriceModal}
            onHide={() => setShowKaratPriceModal(false)}
          >
            <Modal.Header closeButton>
              <Modal.Title>
                {editingKaratPrice?.karat ? `Edit ${editingKaratPrice.karat} Price` : "Add New Karat Price"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Form.Group className="mb-3">
                  <Form.Label>Karat</Form.Label>
                  <Form.Control
                    type="text"
                    value={editingKaratPrice?.karat || ''}
                    onChange={(e) =>
                      setEditingKaratPrice({
                        ...(editingKaratPrice || { karat: "", percentage: 0 }),
                        karat: e.target.value
                      })
                    }
                    placeholder="e.g. 18K, 22K"
                  />
                </Form.Group>
                <Form.Group>
                  <Form.Label>Percentage</Form.Label>
                  <Form.Control
                    type="number"
                    value={editingKaratPrice?.percentage || ''}
                    onChange={(e) =>
                      setEditingKaratPrice({
                        ...(editingKaratPrice || { karat: "", percentage: 0 }),
                        percentage: Number(e.target.value)
                      })
                    }
                    placeholder="Enter percentage"
                  />
                </Form.Group>
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="secondary"
                onClick={() => setShowKaratPriceModal(false)}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                onClick={async () => {
                  if (editingKaratPrice && editingKaratPrice.karat && editingKaratPrice.percentage !== undefined) {
                    await handleUpdateKaratPrice(
                      editingKaratPrice.karat,
                      editingKaratPrice.percentage
                    );
                    setShowKaratPriceModal(false);
                  }
                }}
                disabled={!editingKaratPrice?.karat || editingKaratPrice.percentage === undefined}
              >
                {editingKaratPrice?.karat ? "Save Changes" : "Add Karat Price"}
              </Button>
            </Modal.Footer>
          </Modal>
          {/* Taxes Section */}
          <Row>
            <Col lg={12}>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">All Tax Records</h5>
                <Button
                  variant="success"
                  onClick={() => {
                    setShowModal(true);
                    setIsEditMode(false);
                    setType("");
                    setRate("");
                  }}
                >
                  + Add Tax
                </Button>
              </div>

              <Card>
                <Card.Body>
                  <Table responsive borderless className="align-middle">
                    <thead className="table-light">
                      <tr>
                        <th style={{ width: "5%" }}>#</th>
                        <th style={{ width: "35%" }}>Type</th>
                        <th style={{ width: "20%" }}>Rate (%)</th>
                        <th className="text-end" style={{ width: "20%" }}>
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {taxes.length === 0 ? (
                        <tr>
                          <td colSpan={4} className="text-center py-4">
                            No tax records found.
                          </td>
                        </tr>
                      ) : (
                        taxes.map((tax, index) => (
                          <tr key={tax._id}>
                            <td>{index + 1}</td>
                            <td>{tax.type}</td>
                            <td>{tax.rate}</td>
                            <td className="text-end">
                              <i
                                className="ri-pencil-fill text-primary me-3"
                                style={{ cursor: "pointer" }}
                                onClick={() => handleEditClick(tax)}
                              ></i>
                              <i
                                className="ri-delete-bin-fill text-danger"
                                style={{ cursor: "pointer" }}
                                onClick={() => handleDeleteClick(tax)}
                              ></i>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </Table>
                </Card.Body>
              </Card>
            </Col>
          </Row>

          {/* Attributes Section */}
          <Row className="mb-4">
            <Col lg={12}>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">Attributes</h5>
                <Button
                  variant="success"
                  onClick={() => {
                    setShowAttributeModal(true);
                    setAttributeName("");
                    setAttributeType("string");
                    setOptions([""]);
                    setIsVariable(false);
                    setIsRequired(false);
                  }}
                >
                  + Add Attribute
                </Button>
              </div>

              <Card>
                <Card.Body>
                  {isFetching ? (
                    <div className="text-center py-4">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <p className="mt-2">Loading attributes...</p>
                    </div>
                  ) : (
                    <Table responsive borderless className="align-middle">
                      <thead className="table-light">
                        <tr>
                          <th style={{ width: "5%" }}>#</th>
                          <th style={{ width: "25%" }}>Name</th>
                          <th style={{ width: "15%" }}>Type</th>
                          <th style={{ width: "25%" }}>Options</th>
                          <th style={{ width: "10%" }}>Variable</th>
                          <th style={{ width: "10%" }}>Required</th>
                          <th style={{ width: "10%" }}>Actions</th>
                          <th style={{ width: "10%" }}>Charge</th>
                        </tr>
                      </thead>
                      <tbody>
                        {attributes.length === 0 ? (
                          <tr>
                            <td colSpan={7} className="text-center py-4">
                              {isFetching
                                ? "Loading..."
                                : "No attributes found."}
                            </td>
                          </tr>
                        ) : (
                          attributes.map((attribute, index) => (
                            <tr key={attribute._id}>
                              <td>{index + 1}</td>
                              <td>{attribute.label}</td>{" "}
                              {/* Changed from name to label */}
                              <td>{attribute.type}</td>
                              <td>
                                {attribute.type === "options"
                                  ? attribute.options?.join(", ")
                                  : "-"}
                              </td>
                              <td>{attribute.isVariable ? "Yes" : "No"}</td>{" "}
                              {/* Added isVariable */}
                              <td>{attribute.isCharge ? "Yes" : "No"}</td>
                              {/* Added isCharge */}
                              <td>{attribute.isRequired ? "Yes" : "No"}</td>
                              <td>
                                <i
                                  className="ri-pencil-fill text-primary me-3"
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    handleEditAttributeClick(attribute)
                                  }
                                ></i>
                                <i
                                  className="ri-delete-bin-fill text-danger"
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    handleDeleteAttributeClick(attribute)
                                  }
                                ></i>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </Table>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>

          <Row className="mb-4">
            <Col lg={12}>
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="mb-0">Attribute Sets</h5>
                <Button
                  variant="success"
                  onClick={() => {
                    setShowAttributeSetModal(true);
                    setEditAttributeSet(null);
                    setAttributeSetName("");
                    setSelectedAttributes([]);
                  }}
                  disabled={attributes.length === 0}
                >
                  + Add Attribute Set
                </Button>
              </div>

              <Card>
                <Card.Body>
                  {isFetching ? (
                    <div className="text-center py-4">
                      <div
                        className="spinner-border text-primary"
                        role="status"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                      <p className="mt-2">Loading data...</p>
                    </div>
                  ) : (
                    <Table responsive borderless className="align-middle">
                      <thead className="table-light">
                        <tr>
                          <th style={{ width: "5%" }}>#</th>
                          <th style={{ width: "25%" }}>Name</th>
                          <th style={{ width: "60%" }}>Attributes</th>
                          <th style={{ width: "10%" }}>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {attributeSets.length === 0 ? (
                          <tr>
                            <td colSpan={4} className="text-center py-4">
                              {isFetching
                                ? "Loading..."
                                : "No attribute sets found."}
                            </td>
                          </tr>
                        ) : (
                          attributeSets.map((set, index) => (
                            <tr key={set._id}>
                              <td>{index + 1}</td>
                              <td>{set.name}</td>
                              <td>
                                {set.attributes.map((attr) => (
                                  <span
                                    key={
                                      typeof attr === "object" ? attr._id : attr
                                    }
                                    className="badge bg-primary me-2"
                                  >
                                    {typeof attr === "object"
                                      ? attr.label
                                      : getAttributeNameById(attr)}
                                  </span>
                                ))}
                              </td>
                              <td>
                                <i
                                  className="ri-pencil-fill text-primary me-3"
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    handleEditAttributeSetClick(set)
                                  }
                                ></i>
                                <i
                                  className="ri-delete-bin-fill text-danger"
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    handleDeleteAttributeSetClick(set)
                                  }
                                ></i>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </Table>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>

        {/* Modal for Add/Edit Tax */}
        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>{isEditMode ? "Edit Tax" : "Add New Tax"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group controlId="taxType" className="mb-3">
                <Form.Label>Type</Form.Label>
                <Form.Control
                  type="text"
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                  placeholder="Enter tax type (e.g., GST)"
                />
              </Form.Group>
              <Form.Group controlId="taxRate" className="mb-3">
                <Form.Label>Rate (%)</Form.Label>
                <Form.Control
                  type="number"
                  value={rate}
                  onChange={(e) => setRate(e.target.value)}
                  placeholder="Enter rate"
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleAddOrUpdateTax}>
              {isEditMode ? "Update" : "Add"} Tax
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Modal for delete Tax */}
        <Modal
          show={showDeleteModal}
          onHide={() => setShowDeleteModal(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Confirm Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to delete the tax{" "}
            <strong>{taxToDelete?.type}</strong>?
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowDeleteModal(false)}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              onClick={async () => {
                if (taxToDelete) {
                  try {
                    await deleteTaxes(taxToDelete._id);
                    setTaxes((prev) =>
                      prev.filter((t) => t._id !== taxToDelete._id)
                    );
                  } catch (error) {
                    console.error("Failed to delete tax:", error);
                  }
                }
                setShowDeleteModal(false);
                setTaxToDelete(null);
              }}
            >
              Delete
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Add Attribute Modal */}
        <Modal
          show={showAttributeModal}
          onHide={() => setShowAttributeModal(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {editAttribute ? "Edit Attribute" : "Add New Attribute"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group controlId="attributeName" className="mb-3">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  value={attributeName}
                  onChange={(e) => setAttributeName(e.target.value)}
                  placeholder="Enter attribute name"
                />
              </Form.Group>

              <Form.Group controlId="attributeType" className="mb-3">
                <Form.Label>Type</Form.Label>
                <Form.Select
                  value={attributeType}
                  onChange={(e) =>
                    setAttributeType(
                      e.target.value as
                      | "string"
                      | "number"
                      | "boolean"
                      | "options"
                    )
                  }
                >
                  <option value="string">String</option>
                  <option value="number">Number</option>
                  <option value="boolean">Boolean</option>
                  <option value="options">Select (Dropdown)</option>{" "}
                  {/* 🔁 change "select" to "options" */}
                </Form.Select>
              </Form.Group>

              <Form.Group controlId="isVariable" className="mb-3">
                <Form.Check
                  type="checkbox"
                  label="Is Variable (different for each variant)"
                  checked={isVariable}
                  onChange={(e) => setIsVariable(e.target.checked)}
                />
              </Form.Group>

              <Form.Group controlId="isCharge" className="mb-3">
                <Form.Check
                  type="checkbox"
                  label="Is Charge (additional cost)"
                  checked={isCharge}
                  onChange={(e) => setIsCharge(e.target.checked)}
                  disabled={
                    attributeType !== "number" && attributeType !== "options"
                  }
                />
              </Form.Group>

              <Form.Group controlId="isRequired" className="mb-3">
                <Form.Check
                  type="checkbox"
                  label="Is Required"
                  checked={isRequired}
                  onChange={(e) => setIsRequired(e.target.checked)}
                />
              </Form.Group>

              {attributeType === "options" && (
                <Form.Group controlId="attributeOptions" className="mb-3">
                  <Form.Label>Options</Form.Label>
                  {options.map((opt, idx) => (
                    <div key={idx} className="d-flex mb-2">
                      <Form.Control
                        type="text"
                        value={opt}
                        onChange={(e) =>
                          handleOptionChange(idx, e.target.value)
                        }
                        placeholder={`Option ${idx + 1}`}
                      />
                      <Button
                        variant="outline-danger"
                        className="ms-2"
                        onClick={() => handleRemoveOption(idx)}
                      >
                        Remove
                      </Button>
                    </div>
                  ))}
                  <Button variant="outline-secondary" onClick={handleAddOption}>
                    Add Option
                  </Button>
                </Form.Group>
              )}
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                setShowAttributeModal(false);
                setEditAttribute(null);
                setAttributeName("");
                setAttributeType("string");
                setOptions([""]);
                setIsVariable(false);
                setIsRequired(false);
              }}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={
                editAttribute ? handleUpdateAttribute : handleAddAttribute
              }
              disabled={isLoading || !attributeName}
            >
              {isLoading
                ? editAttribute
                  ? "Updating..."
                  : "Adding..."
                : editAttribute
                  ? "Update Attribute"
                  : "Add Attribute"}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Add Attribute Set Modal */}
        <Modal
          show={showAttributeSetModal}
          onHide={() => {
            setShowAttributeSetModal(false);
            setEditAttributeSet(null);
            setAttributeSetName("");
            setSelectedAttributes([]);
          }}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {editAttributeSet
                ? "Edit Attribute Set"
                : "Add New Attribute Set"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group controlId="attributeSetName" className="mb-3">
                <Form.Label>Set Name</Form.Label>
                <Form.Control
                  type="text"
                  value={attributeSetName}
                  onChange={(e) => setAttributeSetName(e.target.value)}
                  placeholder="Enter attribute set name"
                />
              </Form.Group>

              <Form.Group controlId="attributeSelection" className="mb-3">
                <Form.Label>Select Attributes</Form.Label>
                <div
                  className="border p-3 rounded"
                  style={{ maxHeight: "300px", overflowY: "auto" }}
                >
                  {attributes.length === 0 ? (
                    <p className="text-muted">
                      No attributes available. Please create attributes first.
                    </p>
                  ) : (
                    attributes.map((attribute) => (
                      <Form.Check
                        key={attribute._id}
                        type="checkbox"
                        id={`attr-${attribute._id}`}
                        label={`${attribute.label} (${attribute.type})`}
                        checked={selectedAttributes.includes(attribute._id)}
                        onChange={() => toggleAttributeSelection(attribute._id)}
                        className="mb-2"
                      />
                    ))
                  )}
                </div>
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                setShowAttributeSetModal(false);
                setEditAttributeSet(null);
                setAttributeSetName("");
                setSelectedAttributes([]);
              }}
            >
              Cancel
            </Button>
            <Button
              variant="primary"
              onClick={
                editAttributeSet
                  ? handleUpdateAttributeSet
                  : handleAddAttributeSet
              }
              disabled={
                isLoading ||
                !attributeSetName ||
                selectedAttributes.length === 0
              }
            >
              {isLoading
                ? editAttributeSet
                  ? "Updating..."
                  : "Adding..."
                : editAttributeSet
                  ? "Update Attribute Set"
                  : "Add Attribute Set"}
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Delete Modal */}
        {/* Delete Attribute Confirmation Modal */}
        <Modal
          show={showDeleteAttributeModal}
          onHide={() => setShowDeleteAttributeModal(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Confirm Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to delete the attribute{" "}
            <strong>{attributeToDelete?.label}</strong>?
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowDeleteAttributeModal(false)}
            >
              Cancel
            </Button>
            <Button variant="danger" onClick={handleConfirmDeleteAttribute}>
              Delete
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Delete Attribute Set Confirmation Modal */}
        <Modal
          show={showDeleteAttributeSetModal}
          onHide={() => setShowDeleteAttributeSetModal(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Confirm Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Are you sure you want to delete the attribute set{" "}
            <strong>{attributeSetToDelete?.name}</strong>?
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowDeleteAttributeSetModal(false)}
            >
              Cancel
            </Button>
            <Button variant="danger" onClick={handleConfirmDeleteAttributeSet}>
              Delete
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </React.Fragment>
  );
};

export default Taxes;
